// API Configuration
// In production: REACT_APP_API_URL = https://api.grossy.ru
// In development: REACT_APP_API_URL is empty, use localhost

const API_URL = process.env.REACT_APP_API_URL || '';

/**
 * Get HTTP URL for API calls
 * In production: all requests go through API Gateway
 * In development: requests go to specific services
 */
export function getApiUrl(path: string): string {
  if (API_URL) {
    // Production: all requests go through API Gateway
    // Ensure path starts with /api for gateway routing
    const apiPath = path.startsWith('/api/') ? path : `/api${path}`;
    return `${API_URL}${apiPath}`;
  }

  // Development: route to specific services based on path
  if (path.includes('/bots') || path.includes('/credentials') || path.includes('/subscription')) {
    return `http://localhost:8087${path}`;
  }
  if (path.includes('/trading/') || path.match(/\/strategies\/?\w*/)) {
    // Trading engine routes
    return `http://localhost:8087${path}`;
  }
  if (path.includes('/sandbox-fund')) {
    // Broker connector for sandbox funding
    return `http://localhost:8088${path}`;
  }
  if (path.includes('/pressure')) {
    // Pressure Intelligence engine
    return `http://localhost:8090${path}`;
  }
  // Market data service handles most things
  return `http://localhost:8089${path}`;
}

/**
 * Get WebSocket URL
 * In production: wss://api.grossy.ru/...
 * In development: ws://localhost:PORT/...
 */
export function getWsUrl(path: string): string {
  if (API_URL) {
    // Production: convert https to wss
    const wsBase = API_URL.replace('https://', 'wss://').replace('http://', 'ws://');
    const wsPath = path.startsWith('/api/') ? path : `/api${path}`;
    return `${wsBase}${wsPath}`;
  }

  // Development: route to specific services
  if (path === '/ws' || (path.includes('/strategies') && !path.includes('/brokers'))) {
    // Trading engine WebSocket
    return `ws://localhost:8087${path}`;
  }
  // Market data service WebSocket (price streaming)
  return `ws://localhost:8089${path}`;
}

export { API_URL };
